const brand = "MANICURA";
const baseUrl = "https://manicura-5083fd69e6f3.herokuapp.com";
const baseUrlApi = "https://manicura-5083fd69e6f3.herokuapp.com/api";

export const config = {
  brand,
  baseUrl,
  baseUrlApi,
  defaultUserImage:
    "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg",
  imgbbApiKey: "f369e564a35464c187abaecc81d252ab",
  email: "info@manicura.com",
  phone: "+1 (123) 456-7890",
  address: "123 Main St, City, Country",
  socialMedia: {
    facebook: "https://facebook.com/manicura",
    twitter: "https://twitter.com/manicura",
    instagram: "https://instagram.com/manicura",
    linkedin: "https://linkedin.com/company/manicura",
  },
  theme: {
    // Cambiado: logo ahora apunta directamente al archivo público
    logo: "/logo-manicura.svg",
    brandLogo: "logo-manicura.svg",
    colors: {
      primaryColor: "#E041A6",      // Fucsia vibrante
      secondaryColor: "#51D9C6",    // Verde/agua atractivo
      tertiaryColor: "#F8D90F",     // Amarillo pastel vibrante
      quaternaryColor: "#9547E8",   // Púrpura moderno y fresco
      textMenuColor: "#FCEBFC",     // Blanco rosado para menú
      textMenuHoverColor: "#E04141" // Rojo/fucsia oscuro para hover menú
    },
  },
  mercadopago: {
    clientId: "99922095",
    redirectUrl: baseUrl + "/mercadopago/callback",
  },
  subscription: {
    price: 9.90,
    billingCycle: "monthly",
    conversionRate: 1500,
  },
};
